import * as React from "react";
import { useParticipantsStore } from "../../../../../store/participants.store";
import { useEffect, useState } from "react";
import { inputService } from "../../../../../../modules/inputs/input/InputService";
import { useRemoteMicIndicator } from "../../../../../hooks/mic-indicator.hook";
import { ParticipantListItem } from "./participant-list-item/ParticipantListItem.component";
import { useTranslation } from "react-i18next";
import { placeholderUserlistEmpty } from "../../../../../common-strings.util";
import { remoteStreamingService } from "../../../../../../modules/multiplayer/peer";
export function ParticipantList() {
    const users = useParticipantsStore();
    const speakingUsers = useRemoteMicIndicator();
    const [selectedUserId, setSelectedUserId] = useState(undefined);
    const [showStatus, setShowStatus] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        inputService.deleteAction("ToggleConnectionStatus");
        inputService
            .registerAction("ToggleConnectionStatus", () => {
            setShowStatus((prev) => !prev);
        }, t("common:key-description-key-u", "Toggle connection status"))
            .addKey("KeyU")
            .asDev();
    }, []);
    useEffect(() => {
        users.mutedUsers.forEach((user) => {
            remoteStreamingService.setClientMuted(user.clientId, true);
        });
        users.unmutedUsers().forEach((user) => {
            remoteStreamingService.setClientMuted(user.clientId, false);
        });
    }, [users]);
    const onUserClicked = (user) => {
        setSelectedUserId((prev) => (prev === user.clientId ? undefined : user.clientId));
    };
    const createParticipantList = () => {
        if (users.otherUsers().length > 0) {
            return users.otherUsers().map((user, index) => (React.createElement(ParticipantListItem, { key: index, user: user, selected: user.clientId === selectedUserId, speaking: !!speakingUsers.find((u) => u.clientId === user.clientId), showStatus: showStatus, onClick: () => {
                    onUserClicked(user);
                } })));
        }
        else {
            return (React.createElement("div", { className: "side-panel-list-empty" },
                React.createElement("span", null, placeholderUserlistEmpty())));
        }
    };
    return React.createElement(React.Fragment, null,
        " ",
        createParticipantList(),
        " ");
}
